import User from '@/services/users'
import Request from '@/services/requests'
import Event from '@/services/events'

export default {
  async partialUpdateEvent(context, updateKwargs) {
    const event = await Event.api.update(null, [], [], updateKwargs)

    context.commit('updateEvent', {
      eventRef: event,
    })
  },

  async partialUpdateCurrentRequest(context, updateKwargs) {
    const response = await Request.api.update(null, [], [], updateKwargs)
    context.commit('UPDATE_CURRENT_REQUEST', response)
  },

  // TODO: Edit all below, actions are meant for async edits to state
  //       majority below do not abide by this and need to be converted to mutations

  updateOrganizationDetails({commit}, payload) {
    commit('UPDATE_ORG', payload)
  },
  updateUser({commit}, payload) {
    commit('UPDATE_USER', payload)
  },
  updateHasCompletedHouseholdSurvey({commit}, payload) {
    commit('UPDATE_HAS_COMPLETED_HOUSEHOLD_SURVEY', payload)
  },
  updateHasCompletedFinHealthSurvey({commit}, payload) {
    commit('UPDATE_HAS_COMPLETED_FIN_HEALTH_SURVEY', payload)
  },
  updateUserToken({commit}, payload) {
    commit('UPDATE_USERTOKEN', payload)
  },
  updateCurrentRequest({commit}, payload) {
    commit('UPDATE_CURRENT_REQUEST', payload)
  },

  /**
   * Dispatch this action to update the current language - also updates
   * the user's preferred language in the DB, if they are logged in.
   */
  updateCurrentLanguage({commit}, value) {
    commit('UPDATE_CURRENT_LANGUAGE', value)
  },

  /**
   * Save current donation info in state, so it can be passed between views.
   */
  updateCurrentDonation({commit}, payload) {
    commit('UPDATE_CURRENT_DONATION', payload)
  },
  clearCurrentDonation({commit}) {
    commit('CLEAR_CURRENT_DONATION')
  },

  /**
   * Save current anonymous donor info in state, so it can be passed between views.
   */
  updateCurrentAnonymousDonor({commit}, payload) {
    commit('UPDATE_CURRENT_ANONYMOUS_DONOR', payload)
  },
  clearCurrentAnonymousDonor({commit}) {
    commit('CLEAR_CURRENT_ANONYMOUS_DONOR')
  },

  /**
   * Save current payroll request in state, so it can be passed between views.
   */
  updateCurrentPayrollRequest({commit}, payload) {
    commit('UPDATE_CURRENT_PAYROLL_REQUEST', payload)
  },
  clearCurrentPayrollRequest({commit}) {
    commit('CLEAR_CURRENT_PAYROLL_REQUEST')
  },
  /**
   * Send the auth token in the store to the API to ensure it is valid.
   *
   * @param {object} vuex - The default Vuex object passed to actions.
   *
   * @returns {boolean} - True/false the token in the store is valid.
   */
  validateToken({state}) {
    if (!state.token) {
      return false
    }
    return User.api
      .validateToken(state.token)
      .then(data => !data.needsVerification)
      .catch(err => {
        return false
      })
  },
  /**
   * Refresh the data of the current user in the store.
   *
   * @param {object} vuex - The default Vuex object passed to actions.
   *
   * @returns {Promise} - Promise object representing API call or `null`.
   */
  async refreshCurrentUser({state, commit}) {
    if (!state.token) {
      return null
    }

    return User.api
      .getSelf({token: state.token, tokenType: 'Token'})
      .then(user => {
        commit('UPDATE_USER', user)
        return user
      })
      .then(user => {
        commit(
          'UPDATE_CURRENT_LANGUAGE',
          user.preferredLanguage || window.locationStorage.preferredLanguage || 'en',
        )
        return user
      })
      .catch(err => {
        // do nothing for now
        return null
      })
  },

  /**
   * Check whether user auth is in a bad state, if so force the user to log out.
   *
   * @param {object} vuex - The default Vuex object passed to actions.
   * @param {object} payload - A custom payload for the action.
   * @param {object.object} payload.route - A Vue route object. The action checks
   *    whether this route requires token authentication. If yes, then it validates
   *    that a token exists and is recognized by the API. If either check fails, the
   *    user is forced to log out.
   *
   * @returns {boolean} - True/false the user was logged out.
   */
  checkShouldLogOut({state, commit, dispatch}, {route}) {
    // If the route requires token validation, do it
    if (route.matched.some(r => r.meta.validateTokenOnRefresh)) {
      if (!state.token) {
        Auth.logout()
        return true
      }

      return dispatch('validateToken')
        .then(tokenValid => !tokenValid)
        .then(shouldLogOut => {
          if (shouldLogOut) {
            Auth.logout()
            return true
          }
        })
        .catch(err => {
          Auth.logout()
          return true
        })
    }
    return false
  },
}
